module.exports = __webpack_public_path__ + "img/position-inbox-selected.5358f7c6.svg";